<template>
    <div :style="style" class="m-3 shadow-1" style="background-color: #fdfdfe">
      <b-card no-body
            class="mb-0"
            header="Light"
            border-variant="light"
            header-bg-variant="white">
      <div slot="header">
        <div style="float: left;" class="m-2">
            Sellout
            <b-form-radio-group
              class="ml-3 m-1"
              button-variant="outline-primary"
              v-model="selectedRangeOption"
              :options="rangeOptions"
              name="radios-btn-default"
              buttons
              @change="onRangeChange"
            >
            </b-form-radio-group>
        </div>
        <div style="float: right; margin-top: 4px;">
          <MetricButtons @change-metric="changeMetric"/>
        </div>
        <div style="float: right">
          <b-button size="sm" class="mr-1 mt-1" @click="$emit('open-filters')">Filtro</b-button>
        </div>
      </div>
      <div class="m-1">
        <SelloutMetricPane @change-dashboard-indicator="changeDashboardIndicator"/>
      </div>
      <b-container fluid class="p-1" v-if="areRanges">
        <b-card no-body class="border-0 m-2">
          <b-row>
            <b-col sm="6">
              <b-card class="mb-0 border-0" header="Light" header-bg-variant="white">
                <div slot="header" style="background-color: #00bf8f">
                  <div style="float: left;" class="m-2">
                    <b-form-select 
                      v-model="selectedPivotDimension"
                      :options="pivotDimensions"
                      value-field="dim_value"
                      text-field="description"
                      @change="changeSelloutDimenion"
                    />
                  </div>
                  <div style="float: right; margin-top: 6px;">
                    <b-button class="text-white" size="sm" variant="info" @click="checkIfFilters('salesAnalysis')">
                      Reporte
                    </b-button>
                  </div>
                </div>
                <div>
                  <ColumnLineChart :height="firstCardHeight" :sell-out-chart-data="sellOutChart"/>
                </div>
              </b-card>
            </b-col>
            <b-col sm="6">
              <b-card class="mb-0  border-0" header="Light" header-bg-variant="white">
                <div slot="header">
                  <div style="float: left;" class="m-2">Tiendas sin crecimiento</div>
                  <div style="float: right; margin-top: 8px;">
                    <b-button class="text-white" size="sm" variant="info" @click="checkIfFilters('storeGrowth')">Reporte
                    </b-button>
                  </div>
                </div>
                <div>
                  <StoreGrowth 
                    :height="secondCardHeight"
                    :store-growth="storeGrowth"
                  />
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
      </b-container>
    </b-card>
    </div>
</template>

<script>
  import ColumnLineChart from '@/expertoRetail/atoms/AccumulatedSales/CardComponents/ColumnLineChart/ColumnLineChart'
  import PieDonut from '@/expertoRetail/atoms/AccumulatedSales/CardComponents/PieDonutCards/Cards'
  import SelloutMetricPane from '@/expertoRetail/components/SellOutAccumulatedMetricOpt/SelloutMetricPane'
  import MetricButtons from '@/expertoRetail/atoms/MetricSwitchButtons/MetricSwitchButtons'
  import { DimensionUtils, GeneralUtils } from '@/mixins/index'
  import { baseMetrics } from '../../library/commonParameters'
  import StoreGrowth from '../Dashboard/StoreGrowth'

  export default {
    name: 'TheSelloutCard',
    mixins: [GeneralUtils, DimensionUtils],
    props: {
      salesGrowthIndicators: {
        type: Array,
        required: true
      },
      sellOutChart: {
        type: Object,
        required: true
      },
      storeGrowth: {
        type: Object,
        required: true
      }
    },
    components: {
      ColumnLineChart,
      PieDonut,
      StoreGrowth,
      SelloutMetricPane,
      MetricButtons
    },
    data () {
      return {
        selectedPivotDimension: '',
        style: '',
        firstCardHeight: null,
        secondCardHeight: null,
        nextReport: null,
        rangeOptions: [
          { text: 'Rangos dinámicos', value: 'dynamicRanges' },
          { text: 'Campañas', value: 'campaigns' },
        ]
      }
    },
    created () {
      this.initLoad()
      this.firstCardHeight = this.vuexAvailableHeight * 0.3674
      this.secondCardHeight = this.vuexAvailableHeight * 0.3674
      this.selectedPivotDimension = this.$_dimensionUtils_getDimFromDimension(this.vuexSelectedDim.card1)
    },
    mounted () {
      let val = this.vuexAvailableHeight * 0.745
      this.style = `height: ${val}px; overflow: auto; overflow-x: hidden;`
      this.$store.commit('commit_sellOutDashboardCard_selectedMetricOption', this.selectedDashboardIndicator)
    },
    watch: {
      appMetric () {
        this.initLoad()
      }
    },
    computed: {
      vuexAccumulatedSalesKpiData () {
        return this.$_generalUtils_deepJsonCopy(this.$store.state.sellOutDashboardCard.accumulatedSalesKpiData)
      },
      vuexSelectedDim () {
        return this.$store.state.accumulatedSales.selectedDimension
      },
      appMetric () {
        return this.$store.state.metric
      },
      salesAnalysisFilters () {
        return  this.$store.state.salesAnalysis.filters
      },
      selectedDashboardIndicator () {
        if (this.$store.state.selectedMetricOption !== null) {
          return this.$store.state.sellOutDashboardCard.selectedMetricOption
        } else {
          return this.defaultDashboardIndicator
        }
      },
      defaultDashboardIndicator () {
        return this.isDynamicRangeSelected ? this.dashboardIndicators.find(x => !x.is_campaign) : this.dashboardIndicators.find(x => x.is_campaign)
      },
      vuexAvailableHeight () {
        return this.$_generalUtils_deepJsonCopy(this.$store.state.appAvailableHeight)
      },
      pivotDimensions () {
        return this.$store.getters.dataPivotDimensions
      },
      campaignsRanges () {
        return this.vuexAccumulatedSalesKpiData.filter(accumulatedSalesKpiData => accumulatedSalesKpiData.is_campaign)
      },
      dynamicRanges () {
        return this.vuexAccumulatedSalesKpiData.filter(accumulatedSalesKpiData => !accumulatedSalesKpiData.is_campaign)
      },
      areRanges () {
        return this.ranges.length > 0
      },
      selectedRangeOption: {
        set (selectedRangeOption) {
          this.$store.commit('setDashboardRangeOption', selectedRangeOption)
        },
        get () {
        return this.$store.state.selectedRangeOption
        }
      },
      isDynamicRangeSelected () {
        return this.selectedRangeOption === 'dynamicRanges'
      },
      ranges () {
        return this.isDynamicRangeSelected ? this.dynamicRanges : this.campaignsRanges
      },
      dashboardIndicators () {
        let dashboardIndicators = []
        this.salesGrowthIndicators.forEach((item, index) => {
          dashboardIndicators.push(
            {
              id: index,
              name: item.name,
              salesData: {
                sales1: this.$_formatMetricValue(this.appMetric, item.data[0][baseMetrics[this.appMetric].normal[0]]),
                sales1_no_abb: this.$_formatMetricValueVerbose(this.appMetric, item.data[0][baseMetrics[this.appMetric].normal[0]]),
                sales2: this.$_formatMetricValue(this.appMetric, item.data[0][baseMetrics[this.appMetric].normal[1]]),
                sales2_no_abb: this.$_formatMetricValueVerbose(this.appMetric, item.data[0][baseMetrics[this.appMetric].normal[1]]),
                var: this.$_formatMetricValue('PERCENTAGE', item.data[0][baseMetrics[this.appMetric].varResponse[0]])
              },
              description: item.description,
              arrow: item.data[0][baseMetrics[this.appMetric].varResponse[0]] > 0 ? 'fa fa-arrow-circle-up' : 'fa fa-arrow-circle-down',
              color: item.data[0][baseMetrics[this.appMetric].varResponse[0]] > 0 ? '#538002' : '#CC0F5D',
              factTable: item.fact_name,
              actual_period: item.actual_period,
              last_period: item.last_period,
              data: item.data[0],
              is_campaign: item.is_campaign,
            }
          )
        })
        return dashboardIndicators
      }
    },
    methods: {
      changeSelloutDimenion (dimensionValue) {
        const dimensions = this.$_dimensionUtils_getDimensionParameter(dimensionValue)
        this.$emit('change-sellout-dimension', dimensions)
      },
      checkIfFilters (view) {
        this.$router.push({'name': view})
      },
      initLoad () {
       this.salesGrowthIndicatorsParser()
      },
      salesGrowthIndicatorsParser () {
        const responseData = this.dashboardIndicators
        this.$store.commit('commit_sellOutDashboardCard_accumulatedSalesKpiData', responseData)
      },
      changeMetric (metric) {
        this.$emit('change-metric', metric)
      },
      changeDashboardIndicator (dashboardIndicator) {
        this.$store.commit('commit_accumulatedSalesFactTable', dashboardIndicator.factTable)
        this.$emit('change-dashboard-indicator', dashboardIndicator)
      },
      onRangeChange(rangeOption) {
        const defaultRangeGroupIndicator = this.defaultDashboardIndicator
        this.$store.commit('setDashboardRangeOption', rangeOption)
        this.$store.commit('commit_sellOutDashboardCard_selectedMetricOption', defaultRangeGroupIndicator)
        this.changeDashboardIndicator(defaultRangeGroupIndicator)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/expertoRetail/components/Dashboard/SelloutCard.vue